import { Col, List, Row } from "antd";
import TextComponent from "../../../components/textComponent/TextComponent";
import image from "../../../assets/rsvp7.png";
import avatarImage1 from "../../../assets/staticImages/avatar2.png";
import avatarImage2 from "../../../assets/staticImages/avatar3.png";
import people1 from "../../../assets/people6.png";
import people2 from "../../../assets/people5.png";
import people3 from "../../../assets/people1.png";
import styles from "./VendorHome.module.css";
import {
  CalendarIcon,
  LocIcon,
  ClockIcon,
  UserIcon,
} from "../../../components/icons/Icons";
import { useNavigate } from "react-router-dom";
import ProgressBar from "@ramonak/react-progress-bar";
import eventImg from "../../../assets/eventImg.png";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import PerformanceChart from "./PerformanceChart";
import { MdOutlineStarPurple500 } from "react-icons/md";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { VendorMiddleware } from "../../../Store/Middlewares/VendorMiddleware";
import { DashBoardMiddleware } from "../../../Store/Middlewares/DashBoardMiddleware";
import dummyImg from "../../../assets/imageplace.jpg";
import moment from "moment";
import { ReviewMiddleware } from "../../../Store/Middlewares/ReviewMiddleware";
import userDummyImg from "../../../assets/dummy.jpg";
import { AuthMiddleware } from "../../../Store/Middlewares/AuthMiddleware";

const guestsRows = [
  {
    name: "May 10, 2023 | 08 : 30 PM - Wedding Shower",
    address: "3707 Irving Place, Arnold, MO 63010",
    guestsPresent: 20,
    guestsTotal: 30,
    active: true,
  },
  {
    name: "May 10, 2023 | 08 : 30 PM - Wedding Shower",
    address: "3707 Irving Place, Arnold, MO 63010",
    guestsPresent: 20,
    guestsTotal: 30,
    active: false,
  },
];

export const reviews = [
  {
    title: "James Steven",
    desc: "Not a great Experience with this vendor but One thing is really Like that !Its Very Economical",
    img: people1,
    rating: "5.0",
  },
  {
    title: "David Elson",
    desc: "Not a great Experience with this vendor but One thing is really Like that !Its Very Economical",
    img: people2,
    rating: "",
  },
  {
    title: "Lucy White",
    desc: "Great Experience with this vendor I really Like that !Very Economical",
    img: people3,
    rating: "5.0",
  },
  {
    title: "James Steven",
    desc: "Not a great Experience with this vendor but One thing is really Like that !Its Very Economical",
    img: people1,
    rating: "5.0",
  },
  {
    title: "David Elson",
    desc: "Not a great Experience with this vendor but One thing is really Like that !Its Very Economical",
    img: people2,
    rating: "",
  },
];

export const RenderMultipleTimes = ({ numberOfTimes }) => {
  const componentsArray = [];

  // Use a loop to push the component into the array
  for (let i = 0; i < numberOfTimes; i++) {
    componentsArray.push(<MdOutlineStarPurple500 size={10} color="#ED73AA" />);
  }

  return <div>{componentsArray}</div>;
};

const LeftGroup = ({ item }) => {
  return (
    <div className={styles.itemGroup1}>
      <div className={styles.greenCircle}></div>
      <img
        src={item?.image ? item?.image : dummyImg}
        className={styles.upcomingImg}
      ></img>
      <div className={styles.textGroup}>
        <TextComponent
          text={`${moment(item?.date).format("MMM DD, YYYY")} | ${moment(
            item?.start_time
          ).format("hh:mm A")} - ${item?.name}`}
          textClass={styles.eventTitle}
        />
        <TextComponent text={item.address} textClass={styles.eventAddr} />
      </div>
    </div>
  );
};

const RightGroup = ({ item }) => {
  const navigate = useNavigate();
  return (
    <Row className={styles.itemGroup2}>
      <Col className={styles.group2Item}>
        <TextComponent text="Guests" textClass={styles.infoTitle} />
        <TextComponent
          text={`${item?.no_of_attendee ? item?.no_of_attendee : "0"} / ${
            item?.no_of_guest ? item?.no_of_guest : "0"
          }`}
          textClass={styles.guests}
        />
        <ProgressBar
          completed={
            (`${item?.no_of_attendee ? item?.no_of_attendee : 0}` /
              `${item?.no_of_guest ? item?.no_of_guest : 0}`) *
            100
          }
          className={styles.bar}
          labelClassName={styles.labelBar}
          bgColor="var(--primary-color)"
          height="8px"
          isLabelVisible={false}
        />
      </Col>
    </Row>
  );
};

const VendorHome = () => {
  const { height, width } = useWindowDimensions();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const allEvents = useSelector(
    (state) => state.DashboardReducer.vendorDashboardData
  );

  const user = useSelector((state) => state?.AuthReducer?.user);

  const Analytics = useSelector((state) => state?.ReviewReducer?.Analytics);

  const [loader, setLoader] = useState(true);
  const currentEvent = allEvents?.current;
  const upcomingEvent = allEvents?.upcoming;
  // console.log("Analytics", Analytics);
  // console.log("user", user);

  useEffect(() => {
    dispatch(AuthMiddleware.getUserData());
    dispatch(DashBoardMiddleware.getVendorDashBoard());
    dispatch(ReviewMiddleware.getAnalytics())
      .then(() => setLoader(false))
      .catch(() => setLoader(false));
  }, []);
  const details = [
    {
      title: "Date",
      value: moment(currentEvent?.date).format("MMM DD"),
      icon: <CalendarIcon size={30} />,
    },
    {
      title: "Time",
      value: moment(currentEvent?.start_time).format("ddd hh:mm A"),
      icon: <ClockIcon size={30} />,
    },
    {
      title: "Guests",
      value: `${
        currentEvent?.no_of_attendee ? currentEvent?.no_of_attendee : "0"
      }/${currentEvent?.no_of_guest ? currentEvent?.no_of_guest : "0"}`,
      icon: <UserIcon size={30} />,
    },
    {
      title: "Location",
      value: currentEvent?.address,
      icon: <LocIcon size={30} />,
    },
  ];
  return (
    <Row gutter={[32, 16]} className={styles.mainRow}>
      <Col xs={24} xl={16}>
        <Row gutter={[16, 16]}>
          <Col lg={11} xl={11}>
            <TextComponent textClass={styles.titleText}>
              Welcome,{" "}
              <TextComponent textClass={styles.titleName}>
                {user?.first_name ? `${user?.first_name}!` : "vendor!"}
              </TextComponent>
            </TextComponent>
            <Row>
              <img
                src={currentEvent?.image ? currentEvent?.image : dummyImg}
                alt="Home Image"
                style={{ width: "100%", borderRadius: "10px" }}
                className={styles.homeImg}
              />
            </Row>
          </Col>
          <Col xs={24} lg={13} xl={13}>
            <Row className={styles.topLeftRow}>
              <Col>
                <Row className={styles.currentEventRow}>
                  <TextComponent textClass={styles.currentEventText}>
                    Current Event
                  </TextComponent>
                  <TextComponent textClass={styles.activeText}>
                    Active
                  </TextComponent>
                </Row>
                <Row className={styles.namesRow}>
                  <Col>
                    {currentEvent?.bride?.name && (
                      <TextComponent textClass={styles.namesText}>
                        {`${
                          currentEvent?.bride?.first_name
                            ? currentEvent?.bride?.first_name
                            : "--"
                        } & ${
                          currentEvent?.groom?.first_name
                            ? currentEvent?.groom?.first_name
                            : "--"
                        }`}
                      </TextComponent>
                    )}
                    <TextComponent textClass={styles.namesText2}>
                      {currentEvent?.description}
                    </TextComponent>
                  </Col>
                  {/* <Col className={styles.personImgContainer}>
                    <img
                      src={avatarImage1}
                      alt="Person Image"
                      className={styles.personImg}
                    />
                    <img
                      src={avatarImage2}
                      alt="Person Image"
                      className={styles.personImg}
                    />
                  </Col> */}
                </Row>
              </Col>
              <Col>
                <Row className={styles.detailRow}>
                  <Col xs={24}>
                    <TextComponent textClass={styles.detailHeading}>
                      {currentEvent?.name}
                    </TextComponent>
                    {details.map((item) => (
                      <Row gutter={[8, 8]} className={styles.singleDetailRow}>
                        <Col
                          xs={20}
                          sm={9}
                          md={9}
                          lg={11}
                          xl={10}
                          className={styles.iconText}
                        >
                          {item.icon}
                          <TextComponent textClass={styles.detailTitle}>
                            {item.title}:
                          </TextComponent>
                        </Col>
                        <Col xs={18} sm={15} md={15} lg={13} xl={14}>
                          <TextComponent textClass={styles.detailValue}>
                            {item.value}
                          </TextComponent>
                        </Col>
                      </Row>
                    ))}
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className={styles.eventsRow}>
          <Col xs={24}>
            <Row className={styles.eventsHeadingRow}>
              <TextComponent textClass={styles.eventsHeading}>
                Upcoming Events
              </TextComponent>
              {upcomingEvent?.length > 0 && (
                <TextComponent
                  textClass={styles.eventsViewAll}
                  onClick={() => navigate("/events")}
                >
                  View All
                </TextComponent>
              )}
            </Row>
            <List
              // header={<TableHeader item={headerRow} />}
              className={styles.list}
              itemLayout={width > 991 ? "horizontal" : "vertical"}
              dataSource={upcomingEvent?.length > 0 ? upcomingEvent : []}
              renderItem={(item, index) => (
                <List.Item
                  className={styles.listItem}
                  // onClick={() => navigate("/events/eventDetail")}
                >
                  <Col>
                    <LeftGroup item={item} />
                  </Col>
                  <Col>
                    <RightGroup item={item} />
                  </Col>
                </List.Item>
              )}
            />
          </Col>
        </Row>
      </Col>
      <Col xs={24} xl={8} className={styles.rightCol}>
        <TextComponent textClass={styles.rightColTitle}>
          Analytics
        </TextComponent>
        <Row className={styles.performanceRow}>
          <Col xs={24}>
            <TextComponent textClass={styles.performanceTitle}>
              Performance Metrics
            </TextComponent>
            <PerformanceChart Analytics={Analytics} loader={loader} />
          </Col>
        </Row>
        <Row>
          <Col xs={24}>
            <Row className={styles.reviewsTitleRow}>
              <TextComponent textClass={styles.reviewsTitle}>
                Reviews
              </TextComponent>
              {Analytics?.reviewslist?.length > 0 && (
                <TextComponent
                  textClass={styles.reviewsViewAll}
                  onClick={() =>
                    navigate("/analytics", {
                      state: Analytics,
                    })
                  }
                >
                  View All
                </TextComponent>
              )}
            </Row>
            <Row>
              <Col xs={24}>
                {Analytics?.reviewslist?.slice(0, 3)?.map((review) => (
                  <Row gutter={16} className={styles.singleReviewRow}>
                    <Col>
                      <img
                        src={
                          review.user_image ? review.user_image : userDummyImg
                        }
                        className={styles.reviewImage}
                      />
                    </Col>
                    <Col style={{ flexGrow: 1 }}>
                      <Row className={styles.singleReviewTitleRow}>
                        <TextComponent textClass={styles.singleReviewTitle}>
                          {review?.user_name ? review?.user_name : "--"}
                        </TextComponent>
                        <TextComponent textClass={styles.singleReviewRating}>
                          {review.rating ? (
                            <Row style={{ gap: "5px", alignItems: "center" }}>
                              <TextComponent
                                textClass={styles.singleReviewRating}
                              >
                                Rating: {review?.rating ? review?.rating : 0}
                              </TextComponent>
                              <RenderMultipleTimes
                                numberOfTimes={
                                  review?.rating ? review?.rating : 0
                                }
                              />
                            </Row>
                          ) : (
                            ""
                          )}
                        </TextComponent>
                      </Row>
                      <Row>
                        <TextComponent textClass={styles.singleReviewDesc}>
                          {review?.review ? review?.review : "--"}
                        </TextComponent>
                      </Row>
                    </Col>
                  </Row>
                ))}
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default VendorHome;
